<div class="page-container">
  <!-- Header Unificado -->
  <div class="unified-header">
    <div class="header-left">
      <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 class="page-title">
        <mat-icon class="title-icon">rule</mat-icon>
        Catálogo de Estatus
      </h1>
    </div>
    <button mat-raised-button color="primary" (click)="openCreateDialog()">
      <mat-icon>add_circle_outline</mat-icon>
      Agregar Estatus
    </button>
  </div>

  <!-- Spinner Global -->
  @if (isLoadingSignal()) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
  </div>
  } @else {
  <!-- Filtros Colapsables Compactos -->
  <mat-expansion-panel class="filters-panel-compact" [expanded]="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div style="display: flex; align-items: center; gap: 6px;">
          <mat-icon>filter_list</mat-icon>
          <span>Filtros</span>
          <!-- Spinner local alineado inmediatamente después de "Filtros" -->
          @if (isFilteringSignal()) {
          <mat-progress-spinner mode="indeterminate" diameter="20" class="filter-spinner"
            style="margin-left: 2px;"></mat-progress-spinner>
          }
        </div>
      </mat-panel-title>
      <mat-panel-description>
        <span>{{ filteredStatusesSignal().length }} estatus encontrados</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form class="filtros-form-compact">
      <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
        <mat-label>Buscar estatus</mat-label>
        <input matInput [formControl]="searchControl">
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>

      <div class="filter-actions">
        <button mat-icon-button color="primary" (click)="limpiarFiltros()" type="button" matTooltip="Limpiar Filtros"
          [disabled]="!searchControl.value">
          <mat-icon>filter_alt_off</mat-icon>
        </button>
        <button mat-icon-button color="accent" (click)="forzarRefrescoCompleto()" type="button" matTooltip="Refrescar"
          [disabled]="isLoadingSignal()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </form>
  </mat-expansion-panel>

  <!-- Controles Superiores: Paginador -->
  <div class="controles-superiores">
    @if (filteredStatusesSignal().length > 0) {
    <div class="top-paginator">
      <mat-paginator [length]="filteredStatusesSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
        [pageSizeOptions]="[6, 12, 24]" (page)="handlePageEvent($event)" showFirstLastButtons>
      </mat-paginator>
    </div>
    }
  </div>

  <div class="status-list">
    @for (status of paginatedStatusesSignal(); track status.status) {
    <mat-card class="status-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>flag</mat-icon>
        <mat-card-title>{{ status.nombreSurtimiento }}</mat-card-title>
        <mat-card-subtitle>
          Orden: {{ status.order }} | Clave: {{ status.status }}
          @if (status.nombreCobranza && status.nombreCobranza !== status.nombreSurtimiento) {
          <br>Cobranza: {{ status.nombreCobranza }}
          }
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>{{ status.description }}</p>
        @if (status.variations && status.variations.length > 0) {
        <div class="variations">
          <strong>Variaciones:</strong> {{ status.variations.join(', ') }}
        </div>
        }
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-icon-button (click)="openEditDialog(status)" matTooltip="Editar">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="deleteStatus(status)" matTooltip="Eliminar">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
    } @empty {
    <div class="no-data-message">
      <p>No se encontraron estatus con los filtros aplicados</p>
      <button mat-raised-button color="primary" (click)="searchControl.setValue('')">Limpiar Filtros</button>
    </div>
    }
  </div>

  <!-- Bottom Paginator -->
  @if (filteredStatusesSignal().length > pageSize()) {
  <div class="bottom-paginator">
    <mat-paginator [length]="filteredStatusesSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
      [pageSizeOptions]="[6, 12, 24]" (page)="handlePageEvent($event)" showFirstLastButtons>
    </mat-paginator>
  </div>
  }
  }
</div>